<template>
  <div></div>
</template>

<script>
  import { isRedirectReturnLocation } from "@base/redirect-return";

  export default {
    data () {
      return {
        redirectReturnedWithoutCart: false,
      }
    },

    methods: {
      // Call once the page knows whether this browser can resume the payment.
      handleRedirectReturn (canResume, resume) {
        if (!isRedirectReturnLocation()) return
        if (canResume) {
          if (resume) resume()
        } else {
          this.redirectReturnedWithoutCart = true
        }
      }
    }
  }
</script>

<style scoped>

</style>
